import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import i18n from "micro-i18n";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { IconFacebook, IconLinkedIn, IconXTwitter } from "components/icons/Icons";
import { copyToClipboard, widgetSharing } from "utils";
import { JotType, ShareOption } from "consts";
import classNames from "classnames";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/sharing/ShareTools.scss';

const ShareTools = ({ className, shareableLink, copyMessageKey = "SHARE_ACTION_COPY", jot }) => {
  if (!shareableLink) {
    return null;
  }
  const { href: shareLink, text: shareText, shareable } = shareableLink;
  const defaultCopyMessage = i18n.t(copyMessageKey);
  const [shareCopyMessage, setShareCopyMessage] = useState(defaultCopyMessage);
  const copyInputRef = useRef(null);

  const onCopy = () =>
    copyToClipboard(document, shareLink, () => {
      setShareCopyMessage(i18n.t("SHARE_ACTION_COPIED"));
      copyInputRef?.current?.select();
      jot({ space: "poll", type: JotType.Share, data: { to: ShareOption.Copy, question: shareable } });
    });

  const onShareSocial = (socialPlatform) => {
    widgetSharing.shareSocial(socialPlatform, shareLink, shareText);
    jot({ space: "poll", type: JotType.Share, data: { to: socialPlatform, question: shareable } });
  };

  // useEffect for shareableLink, copyMessageKey, defaultCopyMessage
  useEffect(() => {
    setShareCopyMessage(defaultCopyMessage);
  }, [shareableLink, copyMessageKey, defaultCopyMessage]);

  return (
    <section className={classNames("csw-share-tools", className)}>
      <label className="csw-share-copy-lbl">
        <span className="csw-share-copy-lbl-txt">{i18n.t("SHARE_COPY_LBL")}:</span>
        <input
          className="csw-share-copy outline"
          value={shareLink}
          ref={copyInputRef}
          onClick={onCopy}
          readOnly={true}
          name="csw-share-copy"
        />
        <span className="csw-share-copy-message">{shareCopyMessage}</span>
      </label>
      <div className="csw-share-social">
        <span className="csw-share-social-lbl-txt">{i18n.t("SHARE_SOC_LBL")}:</span>
        <button
          type="button"
          onClick={() => onShareSocial(ShareOption.Facebook)}
          className="csw-share-tools-btn outline"
          title={i18n.t("SHARE_SOC_FACEBOOK")}
          aria-label={i18n.t("SHARE_SOC_FACEBOOK")}
        >
          <IconFacebook iconClassName="csw-share-icon" />
        </button>
        <button
          type="button"
          onClick={() => onShareSocial(ShareOption.Twitter)}
          className="csw-share-tools-btn outline"
          title={i18n.t("SHARE_SOC_TWITTER")}
          aria-label={i18n.t("SHARE_SOC_TWITTER")}
        >
          <IconXTwitter iconClassName="csw-share-icon" />
        </button>
        <button
          type="button"
          onClick={() => onShareSocial(ShareOption.LinkedIn)}
          className="csw-share-tools-btn outline"
          title={i18n.t("SHARE_SOC_LINKEDIN")}
          aria-label={i18n.t("SHARE_SOC_LINKEDIN")}
        >
          <IconLinkedIn iconClassName="csw-share-icon" />
        </button>
      </div>
    </section>
  );
};

ShareTools.propTypes /* remove-proptypes */ = {
  className: PropTypes.string,
  shareableLink: PropTypes.object,
  jot: PropTypes.func.isRequired,
  copyMessageKey: PropTypes.string,
};

export default connect("shareableLink", actions)(ShareTools);
